import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/header/index.tsx");
